import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 640 640",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M560 300V116H120l172 524L72 300 0 55h640v306H308l-26-61 278 1z" })
});
export default SvgLogo;
